/*
 * (c) Copyright, 2008-2015 Massachusetts Institute of Technology.
 *
 *     This material may be reproduced by or for the
 *     U.S. Government pursuant to the copyright license
 *     under the clause at DFARS 252.227-7013 (June, 1995).
 */
define(['ext', 'hvx/modules/CoreModule'], function(Ext, Core){

	return Ext.define('map.ClickListener', {

		constructor: function(renderers) {
			this.renderers = renderers;
			this.activeFeature = null;
			this.activeFeatures = null;

			this.onMapMoveEnd = this.onMapMoveEnd.bind(this);
			this.onRemoveFeature = this.onRemoveFeature.bind(this);
			this.onChangeFeature = this.onChangeFeature.bind(this);

			this.container = new Ext.window.Window({
				title: 'Feature Details',
				maxWidth: 400,
				componentCls:'form-feature-detail',
				renderTo: "cMainComponent-body",
				closeAction: 'hide',
				border: false,
				listeners: {
					close: this.onWindowClose,
					scope: this
				},
				tbar: [{
					itemId: 'previous',
					text: 'Previous',
					iconCls: Ext.baseCSSPrefix + 'tbar-page-prev',
					handler: "onPreviousClicked",
					scope: this
				},"->",{
					itemId: 'next',
					text: 'Next',
					iconCls: Ext.baseCSSPrefix + 'tbar-page-next',
					iconAlign: 'right',
					handler: "onNextClicked",
					scope: this
				}]
			});

			//we listen to the select event so we get click details
			this.olMap = Core.Ext.Map.getMap();
			this.olMap.on("moveend", this.onMapMoveEnd);

			var select = Core.Ext.Map.getSelectInteraction();
			select.on("select", this.onMapViewSelect.bind(this));
			select.getFeatures().on('remove', this.onRemoveFeature.bind(this))

			Core.EventManager.addListener("map-source-set", this.onMapSourceSet.bind(this));

			this.onBufferedFeatureChange = Ext.Function.createBuffered(function(feature, px) {
				if (!this.showFeaturePopup(feature, px)) {
					this.cleanup();
				}
			}, 100, this);
		},

		addRenderer: function(renderer) {
			this.renderers.push(renderer);
		},
		
		removeRenderer: function(renderer) {
			var idx = this.renderers.indexOf(renderer);
			if (idx > -1) {
				this.renderers.splice(idx, 1);
			}
		},

		onWindowClose: function() {
			this.cleanup();
		},

		onMapViewSelect: function(evt) {
			this.lastClickCoord = evt.mapBrowserEvent.coordinate;
			var px = this.olMap.getPixelFromCoordinate(this.lastClickCoord);
			var features = evt.selected;

			if (features.length) {
				this.activeFeature = features[0];

				//get any other clicked features
				//multi-select popup disabled for now
				var clickedFeatures = null; // this.getFeaturesAtPixel(px);
				if (clickedFeatures && clickedFeatures.length > 1) {
					this.activeFeatures = clickedFeatures;

					//show/enable toolbar
					this.container.getDockedItems()[1].show();
				} else {
					//hide/disable toolbar
					this.container.getDockedItems()[1].hide();
				}

				if (!this.showFeaturePopup(this.activeFeature, px)) {
					this.cleanup();
				}
			}else{
				Core.EventManager.fireEvent("hvx.map.view.select", evt, this.container);
			}
		},

		onPreviousClicked: function() {
			var idx = this.activeFeatures.indexOf(this.activeFeature);
			var newIdx = (idx - 1);
			if (newIdx < 0) {
				newIdx = (this.activeFeatures.length - 1);
			}

			this.activeFeature = this.activeFeatures[newIdx];
			var px = this.olMap.getPixelFromCoordinate(this.lastClickCoord);
			this.showFeaturePopup(this.activeFeature, px);

			select.getFeatures().clear();
			select.getFeatures().push(this.activeFeature);
		},

		onNextClicked: function() {
			var idx = this.activeFeatures.indexOf(this.activeFeature);
			var newIdx = (idx + 1) % this.activeFeatures.length;

			this.activeFeature = this.activeFeatures[newIdx];
			var px = this.olMap.getPixelFromCoordinate(this.lastClickCoord);
			this.showFeaturePopup(this.activeFeature, px);

			select.getFeatures().clear();
			select.getFeatures().push(this.activeFeature);
		},

		onMapSourceSet: function(eventName, oldSource, source) {
			this.unlistenToSource(oldSource);

			//clear the overlay on source change (i.e. change rooms)
			this.cleanup();

			this.listenToSource(source);
		},

		listenToSource: function(source) {
			if(source){
				source.on('removefeature', this.onRemoveFeature);
				source.on('changefeature', this.onChangeFeature);
			}
		},

		unlistenToSource: function(source) {
			if(source){
				source.un('removefeature', this.onRemoveFeature);
				source.un('changefeature', this.onChangeFeature);
			}
		},

		cleanup: function() {
			//setting position undefined hides the overlay
			this.container.hide();
			this.container.removeAll();
			this.activeFeature = null;
			this.activeFeatures = null;
		},

		onRemoveFeature: function(event) {
			if (this.activeFeatures) {
				var idx = this.activeFeatures.indexOf(this.activeFeature);
				if (idx >= 0) {
					this.cleanup();
					return;
				}
			}
			
			if (event.feature === this.activeFeature ||
					event.element === this.activeFeature) {
				this.cleanup();
			}
		},

		onChangeFeature: function(event) {
			if (event.feature == this.activeFeature) {
				var px = this.olMap.getPixelFromCoordinate(this.lastClickCoord);
				this.onBufferedFeatureChange(this.activeFeature, px);
			}
		},

		onMapMoveEnd: function() {
			if (this.activeFeature) {
				this.container.setLocalXY(
					this.olMap.getPixelFromCoordinate(this.lastClickCoord));
			}
		},

		hasPopupContent: function() {
			return (this.container.html && this.container.html.trim().length > 0) || this.container.items.getCount() > 0;
		},

		showFeaturePopup: function(feature, px) {
			var handled = this.render(feature);
			if (!handled || !this.hasPopupContent()) {
				return false;
			}

			this.container.show();
			this.container.setLocalXY(px);

			// If box is near the bottom of the window, shift it upwards
			if (px[1] + this.container.getHeight() > window.innerHeight) {
				this.container.setY(px[1] - this.container.getHeight());
			}

			if ((this.container.getPosition()[0] + px[0]) > window.innerWidth) {
				this.container.setX(px[0]);
			}

			return true;
		},

		render: function(feature) {
			//clear the container before rendering
			this.container.removeAll();

			return this.delegateRender(this.container, feature);
		},

		delegateRender: function(container, feature) {
			return this.renderers.reduce(function(prev, curr, idx, arr){
				return curr.render.call(curr, container, feature) || prev;
			}, false);
		},

		getFeaturesAtPixel: function(px) {
			var features = [];
			this.olMap.forEachFeatureAtPixel(px, function(feature, layer){
				features.push(feature);
			});
			return features;
		}

	});

});
